import { Injectable } from '@angular/core';
import { GetUserXRole, GetRoles, RoleBasedFeatureModel, addRoleBasedFeatureModel } from '../models/role.model';
import {HttpClient} from '@angular/common/http';
import { environment} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RoleBasedService {

  
  constructor(private http:HttpClient) { }

  createRole(payload: any){
    return this.http.post<any>(environment.apiUrl+'UserManagement/AddRole/', payload);
  }

  getRoles(): any{
    return this.http.get<GetRoles[]>(environment.apiUrl+'UserManagement/GetAllRoles');
  }

  deleteRoles(id: number){
    return this.http.delete(environment.apiUrl+'UserManagement/AddRole'+id);
  }

  updateRoles(payload: any){
    return this.http.post<any>(environment.apiUrl+'UserManagement/UpdateRole/',payload);
  }

  getFeatures(){
    return this.http.get<RoleBasedFeatureModel[]>(environment.apiUrl+'UserManagement/GetAllFeatures');
  }

  getFeaturesByRoleId(payload: any){
    return this.http.post<RoleBasedFeatureModel[]>(environment.apiUrl+'UserManagement/FetchAllRoleFeatures/', payload);
  }

  addFeaturesToRoles(payload: addRoleBasedFeatureModel){
    return this.http.post<any>(environment.apiUrl+'UserManagement/AddFeaturesToRole/', payload);
  }

  getAllFeaturesBasedActions(payload: any){

    return this.http.post<any>(environment.apiUrl+'UserManagement/FetchAllRoleFeatureActions/' , payload);
  }

  addRolesBasedActions(payload : any){
    return this.http.post<any>(environment.apiUrl+'UserManagement/AddActionsToRoleFeatures/',payload);
  }

  getUserXRole(){
    return this.http.get<GetUserXRole>(environment.apiUrl+'UserManagement/GetAllUsers');
  }

  addUserXRole(payload : any){
    return this.http.post<any>(environment.apiUrl+'UserManagement/UpdateUser/',payload);
  }
  
  getFeaturesBasedOnRoleId(){
    return this.http.get<any>(environment.apiUrl+'UserManagement/FetchAllRoleBasedFeatures');
  }


}
